import styles from './styles'
import React from 'react'
import { css } from 'aphrodite'

const ProgressBar = ({ percentComplete }) => (
  <div className={css(styles.container)}>
    <div className={css(styles.progressContainer)}>
      <div
        className={css(styles.progress)}
        style={{ width: `${percentComplete}%` }}
      />
    </div>
  </div>
)

export default ProgressBar



// WEBPACK FOOTER //
// ./src/components/Media/File/ProgressBar/progressBar.js